import React from 'react';
import 'react-bootstrap';
import MoonLoader from 'react-spinners/MoonLoader';
import misc from './misc.jsx';
import base from './base.jsx';

class InsightContainer extends base.FilteredComponent {
  getDefaultState() {
     return $.extend(super.getDefaultState(), {
      expanded: false
    });
  }

  getContentClass() {
    var className = "insight-container-content";
    if (this.state.expanded) {
      className += " expanded";
    }

    return className;
  }

  getPageClass() {
    var className = "insights-container-page-content"
    if (this.state.expanded) {
      className += " expanded";
    }

    return className;
  }

  getInsightsContent() {
    return
  }

  getHeaderContent() {
    return
  }

  getPageContent() {
    return
  }

  expandInsights() {
    this.setState(currentState => {
      currentState.expanded = !currentState.expanded;

      return currentState;
    });
  }

  render() {
    return <div className="insight-container">
      <div className="insight-header" onClick={this.expandInsights.bind(this)}>
        { this.getHeaderContent() }
      </div>
      <div className="sliding-content">
        <div className={ this.getContentClass() }>
          { this.getInsightsContent() }
        </div>
        <div className={ this.getPageClass() }>
          { this.getPageContent() }
        </div>
      </div>
    </div>
  }
}

class InsightAmountText extends base.BaseComponent {
  render() {
    if (this.props.insightResult) {
      if (this.props.insightResult.insight.isPercentage) {
        var percentage = " %";
        return <span style={this.props.style}>
          <misc.FormattedNumber
            number={this.props.insightResult.insight.value}
            alignLeft={true}
            format={"0,0.0"}
          />
          {percentage}
        </span>
      } else {
        if (this.props.insightResult.insight.value && this.props.insightResult.insight.value != 0) {
          return <misc.Amount
            style={this.props.style}
            amount={this.props.insightResult.insight.value}
            alignLeft={true}
          />
        } else {
          return <span>-</span>
        }
      }
    } else {
      return <span>?</span>
    }
  }
}

class InsightSymbol extends base.BaseComponent {
  render() {
    if (this.props.insightResult) {
      if (this.props.insightResult.insight.isPositive) {
        return <i className="icon-arrow-up" style={this.props.style}/>
      } else if (this.props.insightResult.insight.value > 0) {
        return <i className="icon-arrow-down" style={this.props.style}/>
      }
    }

    return <span style={this.props.style}></span>
  }
}

class Insight extends base.BaseComponent {
  getHeaderText() {
    if (this.props.insightResult) {
      return this.props.insightResult.insight.title;
    } else {
      return this.props.title
    }
  }

  getComparisonDatesDiv(startDate, endDate, period) {
    var formatString = "Do MMM YYYY";

    switch(period) {
      case "day": {
        return <div className="dates">
          <b>{ moment(startDate).format("ddd Do MMM") }</b>
        </div>
      }
      case "week": {
        formatString = "ddd Do MMM";
        break;
      }
      case "month": {
        formatString = "Do MMM YYYY";
        break;
      }
    }

    return <div className="dates">
      <b>{ moment(startDate).format(formatString) }</b>
      <br/>
      until
      <br/>
      <b>{ moment(endDate).format(formatString) }</b>
    </div>
  }

  showInfo() {
    this.props.showCalculation(this.props.insightResult);
  }

  getFooterText() {
    if (this.props.insightResult) {
      return this.props.insightResult.insight.footer;
    } else {
      return "loading..."
    }
  }

  getBlockStyle() {
    if (this.props.insightResult) {
      if (this.props.insightResult.insight.isPositive) {
        return {background: "#42af5f"}
      } else {
        if (this.props.insightResult.insight.value > 0) {
          //negative
          return {background: "#fe465c"}
        }
      }
    }

    return {background: "#03b0ea"}
  }

  getLoaderView() {
    if (this.props.insightResult) {
      return
    }

    return <div className="loading-view">
      <div className="spacer"/>
      <MoonLoader size={25}/>
      <div className="spacer"/>
    </div>
  }

  render() {
    return <div
      className="insight"
      style={ this.getBlockStyle() }
    >
      <div className="insight-header">
      { this.getHeaderText() }
        <i className="icon-information"
           onClick={this.showInfo.bind(this)}
           onMouseDown={this.props.mouseDownEvent}
           onMouseUp={this.props.mouseUpEvent}
        />
      </div>
      <div className="insight-values">
        <InsightSymbol insightResult={this.props.insightResult}/>
        <span className="value-text">
          <InsightAmountText insightResult={this.props.insightResult}/>
        </span>
      </div>
      <div className="insight-footer">
        { this.getFooterText() }
      </div>
      { this.getLoaderView() }
    </div>
  }
}

class InsightCalculationPanel extends base.BaseComponent {
  getComparisonDatesDiv(startDate, endDate, period) {
    var formatString = "Do MMM YYYY";

    switch(period) {
      case "day": {
        return <div className="dates">
          <b>{ moment(startDate).format("ddd Do MMM") }</b>
        </div>
      }
      case "week": {
        formatString = "ddd Do MMM";
        break;
      }
      case "month": {
        formatString = "Do MMM YYYY";
        break;
      }
    }

    return <div className="dates">
      <span style={{"color":"rgba(33, 33, 33, 0.6)"}}>From 5am </span>
      <b>{ moment(startDate).format(formatString) }</b>
      <span style={{"color":"rgba(33, 33, 33, 0.6)"}}> until 5am </span>
      <b>{ moment(endDate).format(formatString) }</b>
    </div>
  }

  getSymbol() {
    if (this.props.insightResult) {
      if (this.props.insightResult.insight.isPositive) {
        return <i className="icon-arrow-up" style={this.getStyle()}/>
      } else if (this.props.insightResult.insight.value > 0) {
        return <i className="icon-arrow-down" style={this.getStyle()}/>
      }
    } else {
      return <span/>
    }
  }

  getStyle() {
    if (this.props.insightResult) {
      if (this.props.insightResult.insight.isPositive) {
        return {"color": "#42af5f"}
      } else if (this.props.insightResult.insight.value > 0) {
        return {"color": "#fe465c"}
      }
    } else {
      return {}
    }
  }

  getResult() {
    if (this.props.insightResult.currentValue == 0 && this.props.insightResult.previousValue == 0) {
      return <div className="result">
        no data for selected period
      </div>
    } else {
      return <div className="result">
        = <span className="value"><InsightAmountText insightResult={this.props.insightResult} style={this.getStyle()}/></span>
        <InsightSymbol style={this.getStyle()} insightResult={this.props.insightResult}/>
      </div>
    }
  }


  render() {
    return <div className="receipt-panel calculation-panel">
      <div className="receipt-container">
        <div className="section">
          <div className="title">
            PREVIOUS PERIOD
          </div>
          <div className="numbers-container">
            { this.getComparisonDatesDiv(this.props.insightResult.dates.previousStartDate, this.props.insightResult.dates.previousEndDate, this.props.insightResult.dates.period) }
            <b><misc.Amount amount={this.props.insightResult.previousValue} alignLeft={true}/></b>
          </div>
          <div className="title">
            CURRENT PERIOD
          </div>
          <div className="numbers-container">
            { this.getComparisonDatesDiv(this.props.insightResult.dates.startDate, this.props.insightResult.dates.endDate, this.props.insightResult.dates.period) }
            <b><misc.Amount amount={this.props.insightResult.currentValue} alignLeft={true}/></b>
          </div>
        </div>
        <div className="section footer">
          <div className="result-block">
            {this.getResult()}
          </div>
        </div>
      </div>
    </div>
  }
}

class InsightDataBlock extends base.BaseComponent {
  getHeader() {
    if (this.props.header) {
      return <div className="insight-header">
        {this.props.header}
      </div>
    }
  }

  getPrimaryValue() {
    if (this.props.primaryIsCurrency) {
      return <div className="primary">
        <misc.Amount
          amount={this.props.primaryValue}
          alignLeft={!this.props.alignRight}
        />
        { this.getValuesList() }
      </div>
    } else {
      return <div className="primary">
        <misc.FormattedNumber
          number={this.props.primaryValue}
          alignLeft={!this.props.alignRight}
          format="0,0"
        />
        { this.getValuesList() }
      </div>
    }
  }

  getValuesList() {
    if (this.props.values) {
      return <div className="values">
        { this.props.values.map(item => {
            var value = item.value;
            if (item.isCurrency) {
              value = <misc.Amount amount={item.value}/>
            }

            if (!item.showIfZero && (!item.value || item.value == 0)) {
              return
            }

            var spacerClassName = this.props.alignRight ? "spacer" : "";

            return <div className="value-block" key={item.label}>
              <div className={spacerClassName}/>
              <div className="item-label">
                { item.label }
              </div>
              <div className="item-value">
                { value }
              </div>
            </div>
          })
        }
      </div>
    }
  }

  getLoaderView() {
    if (this.props.loading) {
      return <div className="loading-view">
        <div className="spacer"/>
        <MoonLoader size={25}/>
        <div className="spacer"/>
      </div>
    }
  }

  render() {
    var flexBoxClass = "flex-box";
    if (this.props.leftAlign) {
      flexBoxClass += " left-align";
    }
    return <div className="insight-data-block">
      { this.getHeader() }
      <div className={flexBoxClass}>
        { this.getPrimaryValue() }
      </div>
      { this.getLoaderView() }
    </div>
  }
}

module.exports = {
  InsightContainer: InsightContainer,
  Insight: Insight,
  InsightDataBlock: InsightDataBlock,
  InsightCalculationPanel: InsightCalculationPanel
}
